'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var format = require('date-fns/format');
var parseISO = require('date-fns/parseISO');
var bumbag = require('bumbag');
var _get = require('lodash/get');
var _isEmpty = require('lodash/isEmpty');
var components_DescriptionLabel = require('../../../components/DescriptionLabel.js');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var format__default = /*#__PURE__*/_interopDefaultLegacy(format);
var parseISO__default = /*#__PURE__*/_interopDefaultLegacy(parseISO);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);

var ServiceDetails = function ServiceDetails(_ref) {
  var created = _ref.created,
      modality = _ref.modality,
      practice = _ref.practice,
      staff = _ref.staff,
      invoiceReference = _ref.invoiceReference;
  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Columns, {
    minBreakpoint: "mobile"
  }, invoiceReference ? /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, null, /*#__PURE__*/React__default["default"].createElement(components_DescriptionLabel["default"], null, "INVOICE REFERENCE"), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    fontWeight: "semibold"
  }, invoiceReference)) : /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, null), /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    textAlign: "right"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontSize: "150",
    marginRight: "major-1"
  }, format__default["default"](parseISO__default["default"](created), 'dd/MM/yyyy')), /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontSize: "150"
  }, format__default["default"](parseISO__default["default"](created), 'hh:mma')))), /*#__PURE__*/React__default["default"].createElement(bumbag.Columns, {
    minBreakpoint: "mobile",
    marginTop: "0"
  }, staff && /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, null, /*#__PURE__*/React__default["default"].createElement(components_DescriptionLabel["default"], null, "PROVIDER"), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    fontWeight: "semibold"
  }, staff.firstName, " ", staff.lastName), modality && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    lineHeight: "1.1em"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontSize: "150"
  }, modality.displayName))), practice && /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    position: "relative"
  }, /*#__PURE__*/React__default["default"].createElement(components_DescriptionLabel["default"], null, "PRACTICE"), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    fontWeight: "semibold"
  }, practice.displayName), /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    lineHeight: "1.1em"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontSize: "150"
  }, _get__default["default"](practice, 'showAddress', true) && !_isEmpty__default["default"](practice.address) && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    lineHeight: "1.1em"
  }, practice.address, /*#__PURE__*/React__default["default"].createElement("br", null), practice.city, ", ", practice.state, /*#__PURE__*/React__default["default"].createElement("br", null)), (practice.landline || practice.mobile) && /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
    href: "tel:" + (practice.landline || practice.mobile)
  }, practice.landline || practice.mobile))))));
};

exports["default"] = ServiceDetails;
